module.exports = __webpack_public_path__ + "img/zero-image.c0262bb9.png";